export default "__VITE_ASSET__CZ3g60hz__"